{
  "checkedInTitle": "Вы зарегистрировались",
  "postCheckInInstructions": "Инструкции после регистрации",
  "appointmentDetails": "Детали назначения",
  "notifyWarehouse": "Мы уведомили склад о вашем прибытии, чтобы они могли проверить доступность",
  "waitForStaff": "Пожалуйста, ожидайте дальнейших инструкций от персонала склада",
  "unplannedDescription": "Похоже, у вас нет записи. Пожалуйста, ожидайте дальнейших инструкций от персонала склада.",
  "whatsappDelay": "Первое сообщение WhatsApp может занять до одной минуты.",
  "bookNextTitle": "Забронируйте визит на следующий раз",
  "bookNextBody": "Зарегистрируйтесь в Opendock, чтобы забронировать визит в следующий раз, когда придёте на этот объект",
  "helpFooter": "Если вам нужна помощь или дополнительная информация, пожалуйста, свяжитесь с персоналом склада",
  "finalize": "Завершить ({seconds})"
}
